import { useState } from "react";
import {
  InternalReportViewV1Schema,
  ReportGenerateResultV1Schema,
  type InternalReportViewV1,
} from "@enrein/shared-contracts";
import type { StudioApiClient } from "./api.js";

export function ReportsPanel({
  api,
  projectId,
}: {
  readonly api: StudioApiClient;
  readonly projectId: string | null;
}) {
  const [status, setStatus] = useState<string | null>(null);
  const [report, setReport] = useState<InternalReportViewV1 | null>(null);

  if (!projectId) {
    return <p className="empty-state">Select a project to manage reports.</p>;
  }

  const selectedProjectId = projectId;

  async function generate() {
    setStatus(null);
    try {
      const result = ReportGenerateResultV1Schema.parse(await api.generateReport(selectedProjectId));
      setStatus(`Report ${result.reportId} - ${result.lifecycleStatus}`);
      const view = await api.getCurrentInternalReport(selectedProjectId);
      setReport(view);
    } catch (err) {
      setStatus(err instanceof Error ? err.message : String(err));
    }
  }

  async function refresh() {
    setStatus(null);
    try {
      const view = InternalReportViewV1Schema.parse(await api.getCurrentInternalReport(selectedProjectId));
      setReport(view);
    } catch (err) {
      setReport(null);
      setStatus(err instanceof Error ? err.message : String(err));
    }
  }

  return (
    <div>
      <p>Generate and view the internal search readiness report for this project.</p>
      <div className="button-row">
        <button type="button" onClick={() => void generate()}>
          Generate report
        </button>
        <button type="button" onClick={() => void refresh()}>
          Refresh current
        </button>
      </div>
      {status ? <p className="action-status">{status}</p> : null}
      {report ? (
        <article className="report-card">
          <h3>{report.headline}</h3>
          {report.staleBanner ? <p className="warning">{report.staleBanner}</p> : null}
          <p>
            Coverage: {report.coverage.coveragePercent}% ({report.coverage.checksPassed}/
            {report.coverage.checksTotal} passed)
          </p>
          <ul>
            {report.checks.map((check) => (
              <li key={check.checkId}>
                {check.checkId}: {check.disposition}
              </li>
            ))}
          </ul>
        </article>
      ) : null}
    </div>
  );
}
